<page-toolbar [pageActions]="pageActions" title="{{ 'pages.dynamic-content-history' | translate }}: {{entrance?.title || entry?.title}}"></page-toolbar>

<page-content [noPadding]="true">
  <div class="history-container">
  <div class="table-card">
    <table class="history-table">
      <thead>
      <tr>
        <th class="col-action">Aktion</th>
        <th class="col-user">Benutzer</th>
        <th class="col-target">Betroffener Inhalt</th>
        <th class="col-changes">Änderungen</th>
        <th class="col-date">Datum & Zeit</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of histories" [class.row-deleted]="item.isDeleted">

        <!-- Method / Action Icon -->
        <td class="col-action">
            <span class="action-icon patch" *ngIf="item.method === 'patch'" title="Aktualisiert">
              <svg viewBox="0 0 24 24"><path fill="currentColor"
                                             d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1a6.88 6.88 0 0 0 0 9.8c2.73 2.7 7.15 2.7 9.88 0c1.36-1.35 2.04-3.1 2.04-4.88h2c0 2.28-.87 4.56-2.61 6.3a8.9 8.9 0 0 1-12.65 0a8.94 8.9 0 0 1 0-12.63c3.48-3.47 9.13-3.47 12.61 0L21 3v7.12Z"/></svg>
            </span>
          <span class="action-icon remove" *ngIf="item.method === 'remove'" title="Gelöscht">
              <svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12Z"/></svg>
            </span>
          <span class="action-icon post" *ngIf="item.method === 'post'" title="Erstellt">
              <svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"/></svg>
            </span>
        </td>

        <!-- User Name -->
        <td class="col-user"><div class="user-badge"><span class="user-name">{{ item.user.email }}<br>{{ item.user.name }}</span></div></td>

        <!-- Affected Target Item -->
        <td class="col-target">
          <div class="target-item">
            <span class="type-tag">{{ item.itemType }}</span>
            <strong class="item-title">{{ item.itemTitle }}</strong>
          </div>
        </td>

        <!-- Inline Detailed Changes -->
        <td class="col-changes">
          <div *ngIf="item.isDeleted" class="badge badge-deleted">
            Eintrag vollständig gelöscht
          </div>

          <div *ngIf="!item.isDeleted && item.method === 'post'" class="badge badge-created">
            Eintrag erstellt
          </div>

          <div *ngIf="!item.isDeleted && item.method !== 'post' && item.changes.length === 0" class="no-changes">
            Keine inhaltlichen Änderungen
          </div>

          <div class="changes-list" *ngIf="!item.isDeleted && item.changes.length > 0">
            <ng-container *ngFor="let change of item.changes">

              <!-- Title Change -->
              <div class="change-tag" *ngIf="change.type === 'title'">
                <span class="label">Titel:</span>
                <span class="val">Geändert zu "{{ change.newValue }}"</span>
              </div>

              <!-- Text / Content Change -->
              <div class="change-tag" *ngIf="change.type === 'content'">
                <span class="label">Text:</span>
                <span class="val">Inhalt aktualisiert</span>
              </div>

              <!-- Media Files Change -->
              <div class="change-tag" *ngIf="change.type === 'mediaFiles'">
                <span class="label">Medien:</span>
                <span class="val">{{ change.newValue?.length - change.oldValue?.length }} Datei(en)</span>
              </div>

              <!-- Documents / Data Files Change -->
              <div class="change-tag" *ngIf="change.type === 'dataFiles'">
                <span class="label">Dokumente:</span>
                <span class="val">{{ change.newValue?.length - change.oldValue?.length }} Datei(en)</span>
              </div>

              <!-- Generic Fallback for Other Fields -->
              <div class="change-tag" *ngIf="change.type === 'other'">
                <span class="label">{{ change.fieldName }}:</span>
                <span class="val">Aktualisiert</span>
              </div>

            </ng-container>
          </div>
        </td>

        <!-- Timestamp -->
        <td class="col-date">
          <div class="date-wrapper">
            <span class="date">{{ item.timestamp | date:'dd.MM.yyyy' }}</span>
            <span class="time">{{ item.timestamp | date:'HH:mm' }}</span>
          </div>
        </td>

      </tr>
      </tbody>
    </table>
  </div>
</div>
</page-content>
